<template>
  <main
    @scroll="scrollmethod" class="container-fluid bkPage"  >
    <div class="container-fluid select">
      <div class="search mb-3">
        <div class="titleStyle mt-5 mb-3">加入現有家戶</div>
        <div class="subTitleStyle mb-3">請選擇欲加入的家戶</div>
        <div>
          <div>
            <form class="form">
              <div class="input-group input-lg">
                <div class="input">
                  <input
                    type="text"
                    name="Search"
                    id="Search"
                    class="form-control"
                    v-model="keyword"
                    @keydown.enter="doSearch()"
                    placeholder="輸入姓名、身分證進行搜尋..."
                    alt="ch"
                    maxlength="40"
                    @input="checkKeyword"
                  />
                  <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                    >清除</span
                  >
                </div>
                <button
                  class="btn btn-primary btn-icon"
                  type="submit"
                  @click.prevent="doSearch()"
                >
                  <i class="icon-search i-24"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <section class="newTable mb-5">
        <table class="table datatable insurance-green">
          <thead>
            <tr>
              <th :width="Math.floor(718 * 0.2) + 'px'">
                <span style="margin-left: 38px">#</span>
              </th>
              <th
                :class="
                  sortItem['houseHoldername'] != undefined
                    ? 'sorting ' +
                      (sortItem['houseHoldername'] == true
                        ? 'sorting_asc'
                        : 'sorting_desc')
                    : 'sorting'
                "
                @click="
                  sortP(getFamilyMemberByconditionResult, 'name', 'houseHolder')
                "
                :width="Math.floor(718 * 0.25) + 'px'"
              >
                戶長姓名
              </th>
              <th :width="Math.floor(718 * 0.25) + 'px'">身分證</th>
              <th :width="Math.floor(718 * 0.3) + 'px'">生日</th>
              <th
                :width="Math.floor(718 * 0.17) + 'px'"
                :class="
                  sortItem['houseHolderage'] != undefined
                    ? 'sorting ' +
                      (sortItem['houseHolderage'] == true
                        ? 'sorting_asc'
                        : 'sorting_desc')
                    : 'sorting'
                "
                @click="
                  sortP(getFamilyMemberByconditionResult, 'age', 'houseHolder')
                "
              >
                年齡
              </th>
            </tr>
          </thead>
          <tbody v-if="!_.isEmpty(getFamilyMemberByconditionResult)">
            <tr
              v-for="(item, i) in getFamilyMemberByconditionResult"
              :key="`familiy-item-${i}`"
            >
              <td :width="Math.floor(718 * 0.17) + 'px'">
                <div class="d-flex align-items-center">
                  <div class="radio radio-inline mr-auto">
                    <input
                      type="radio"
                      v-model="selectedHolder"
                      :id="`family-${i + 1}`"
                      :value="item.csidno"
                      @change="handleChange(item.csidno)"
                    />
                    <label style="" :for="`family-${i + 1}`">{{ i + 1 }}</label>
                  </div>
                  <div style="width: 30px">
                    <div v-if="item.vip_lvl" class="controlAvatarLevel">
                      <level :lv="Number(item.vip_lvl)" />
                    </div>
                    <div class="d-flex justify-content-center">
                      <Avatar
                        :gender="Number(item.sex)"
                        :size="20"
                        :height="20"
                      />
                    </div>
                  </div>
                </div>
              </td>
              <td :width="Math.floor(718 * 0.36) + 'px'">
                <Tooltip
                  :position="i < 4 ? 'bottom' : 'top'"
                  :id="
                    item.csidno.includes('~') || item.csidno.includes('#')
                      ? ''
                      : item.csidno
                  "
                  :birthday="formatDate(item.birthday)"
                  :name="item.name"
                >
                  <div class="font-12 breakLine text-left">
                    <a :class="item.name ? 'link text-underline' : ''">
                      <TruncateTool
                        :content="item.name | getMaskName"
                        :showTipEvent="false"
                      ></TruncateTool>
                    </a>
                  </div>
                </Tooltip>
              </td>
              <td :width="Math.floor(718 * 0.35) + 'px'">
                <div
                  v-if="
                    item.csidno &&
                    (item.csidno.includes('~') || item.csidno.includes('#'))
                  "
                ></div>
                <div v-else>{{ item.csidno | getMaskID }}</div>
              </td>
              <td :width="Math.floor(718 * 0.35) + 'px'" v-if="item.birthday">
                {{ formatDate(item.birthday) | getMaskBirthday }}
              </td>
              <td :width="Math.floor(718 * 0.35) + 'px'" v-else>— —</td>
              <td :width="Math.floor(718 * 0.17) + 'px'">{{ item.age }} 歲</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center mt-5" colspan="5">
                <div
                  :class="{ 'loadingArea section-loading': isLoading }"
                  style="display: inline-block"
                ></div>
                <h3 class="mb-4" style="display: inline-block">
                  {{ this.remoteDataMessage }}
                </h3>
              </td>
            </tr>
          </tbody>
        </table>
        <Fixed-Bottom ref="fixedBtn">
          <template slot="@function">
            <div class="actions text-right">
              <button
                type="button"
                class="btn btn-default btn-custStyle mr-3"
                @click="goBack()"
              >
                取消
              </button>
              <button
                :disabled="selectedHolder === ''"
                @click="goAddFamily()"
                class="btn btn-primary btn-custStyle"
              >
                下一步
              </button>
            </div>
          </template>
        </Fixed-Bottom>
      </section>
    </div>
  </main>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";

import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { mapGetters } from "vuex";
import { getAllHouseholderBySales, getAllFamily } from "@/service";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import Level from "../../components/Level";
import TruncateTool from "@/desktop/views/mv/PolicyInfo/components/TruncateTool";
import Tooltip from "@/desktop/components/ToolTip";

export default {
  name: "bkAddToFamily",
  mixins: [commonMixin],
  data() {
    return {
      //戶長列表
      getAllHouseholderBySalesResult: [],
      //搜尋結果
      getFamilyMemberByconditionResult: [],
      //搜尋條件
      keyword: "",
      //選擇成員
      selectedHolder: "",
      //排序用
      sortItem: {},
      remoteDataMessage: "資料讀取中，請稍候...",
      isLoading: false,
      isReAddFamily: false,
      //是否為保代用頁面
      isFromBank: true,
    };
  },
  components: {
    Avatar,
    FixedBottom,
    Level,
    TruncateTool,
    Tooltip,
  },
  computed: {
    ...mapGetters(["UserItems", "FamilyResultFilter"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //從重新歸戶>加入現有家戶 返回上一頁需過濾原戶長
      if (from.name === "checkBKAddFamily") {
        vm.isReAddFamily = true;
      }
    });
  },
  methods: {
    moment,
    checkKeyword() {
      this.keyword = this.keyword.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');
      if (this.stringBytes(this.keyword, false, 40) > 40) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true, 40));
      }
    },
    handleChange(csidno) {
      this.selectedHolder = csidno;
    },
    cleanSearch() {
      this.keyword = "";
      this.init();
    },
    deleteSortItemByKeys(sortIndex) {
      Object.keys(this.sortItem).forEach((item) => {
        if (item.includes(sortIndex)) {
          delete this.sortItem[item];
        }
      });
    },
    sortP(sortArray, key, sortIndex) {
      if (
        this.sortItem[sortIndex + key] == false ||
        !this.sortItem[sortIndex + key]
      ) {
        this.deleteSortItemByKeys(sortIndex);
        this.sortItem[sortIndex + key] = true;

        sortArray = sortArray.sort(function(a, b) {
          return (a[key] ? String(a[key]) : "").localeCompare(
            b[key] ? String(b[key]) : "",
            undefined,
            {
              numeric: true,
              sensitivity: "base",
            }
          );
        });
      } else {
        this.deleteSortItemByKeys(sortIndex);
        this.sortItem[sortIndex + key] = false;
        sortArray = sortArray.sort(function(a, b) {
          return (b[key] ? String(b[key]) : "").localeCompare(
            a[key] ? String(a[key]) : "",
            undefined,
            {
              numeric: true,
              sensitivity: "base",
            }
          );
        });
      }
    },
    scrollmethod(e) {
      // ----滾動顯示/隱藏----
      this.$refs.fixedBtn.scrollEvent();
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight >
        e.srcElement.scrollHeight - 100
      ) {
        //當前選所有客戶且以滾到底
        if (this.isRelate == "Y" && this.currentPage == this.totalpages_all) {
          return;
        }

        //當前選尚未歸戶且以滾到底
        if (!this.isRelate == "N" && this.currentPage == this.totalpages_no) {
          return;
        }

        this.scrollDataLoading = true;
        this.scrollMessageLoading = true;
        this.currentPage = this.currentPage + 1;
      }
    },
    doSearch() {
      if (!this.keyword) {
        this.init();
        return false;
      }
      let searchCusts = this.getAllHouseholderBySalesResult.filter(
        (item) =>
          (item.name && item.name.includes(this.keyword)) ||
          (item.csidno && item.csidno.includes(this.keyword))
      );
      if (searchCusts && searchCusts.length > 0) {
        this.getFamilyMemberByconditionResult = [...searchCusts];
      } else {
        this.getFamilyMemberByconditionResult = [];
        this.remoteDataMessage = "查無資料，請確認您輸入之資料是否正確";
        this.isLoading = false;
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");
        return dd;
      } else {
        return "";
      }
    },
    goAddFamily() {
      getAllFamily(
        this.$store.state.userInfo.id,
        this.selectedHolder,
        this.isFromBank
      ).then((result) => {
        if (result.header && result.data) {
          this.getAllFamilyResult = result.data;
        } else {
          this.getAllFamilyResult = [];
        }
        // 檢核家戶既有人數+重新歸戶加入的人數 不得超過50人+
        let allFamilyNumber = this.getAllFamilyResult
          ? this.getAllFamilyResult.length
          : 0;
        let FamilyResultFilter = this.FamilyResultFilter
          ? this.FamilyResultFilter.length
          : 0;
        let FamilyCount = allFamilyNumber + FamilyResultFilter;
        if (FamilyCount > 50) {
          this.$toast.info({ title: "家戶成員不得超過50人+" });
          return;
        }
        this.$router.push({
          name: "checkBKAddFamily",
          params: {
            selectedHolder: this.selectedHolder,
            AllFamilyResult: this.getAllFamilyResult,
          },
        });
      });
    },
    // 上一頁
    goBack() {
      let backTo = this.getHistory("bkAddToFamily");
      this.$toast.info({ title: "歸戶失敗" });
      this.$router.push({
        name: backTo ? backTo : "bkRelation",
      });
    },
    init() {
      this.getAllHouseholderBySalesResult = [];
      this.getFamilyMemberByconditionResult = [];
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.isLoading = true;
      getAllHouseholderBySales(
        this.$store.state.userInfo.id,
        this.isFromBank
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.getAllHouseholderBySalesResult = result.data;
          if (this.isReAddFamily && this.UserItems && this.UserItems.csidno) {
            this.getAllHouseholderBySalesResult = this.getAllHouseholderBySalesResult.filter(
              (item) => item.csidno != this.UserItems.csidno
            );
          }
          this.getFamilyMemberByconditionResult = this.getAllHouseholderBySalesResult;
        }
        this.remoteDataMessage =
          "無任何家戶 \n (請先將客戶完成歸戶，才能開始使用保單健檢)";
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.init();
  },
  created() {
    // 是否需過濾原戶長
    this.isReAddFamily = this.$route.params.isReAddFamily || false;
  },
};
</script>
<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
.mb-100 {
  margin-bottom: 100px;
}
.w-120 {
  width: 120px;
}
.w-181 {
  width: 181px;
}
.h-44 {
  height: 44px;
}
.fw-600 {
  font-weight: 600;
}
.titleStyle {
  width: 120px;
  height: 28px;
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #027a39;
}
.subTitleStyle {
  width: 144px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #323a45;
}
.loadingArea {
  width: 30px;
  height: 30px;
}
.btn-custStyle {
  padding-top: 9px !important;
  width: 120px;
  height: 40px;
}
.controlAvatarLevel {
  height: 17px;
}
.bkPage {
  padding-top: 0px !important;
  padding-bottom: 70px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
</style>
